var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9EE893EA-4470-44A8-90B2-E4510C76C953") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1.start.Sept17",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "announcement-details-NO-NAV--desktop",
    transform: "translate(-934.000000, -1653.000000)",
    fillRule: "nonzero",
    stroke: "#006F44",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "misc/related-announcement-copy-misc/related-announcement/default",
    transform: "translate(343.000000, 1616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button/circular-arrow/default",
    transform: "translate(591.062691, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button/arrow/default"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 20.8935724,
    cy: 20.9874761,
    rx: 20.1435724,
    ry: 20.2374761
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(21.500000, 21.500000) scale(-1, 1) rotate(180.000000) translate(-21.500000, -21.500000) ",
    points: "19 16 24 21.5 19 27"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.b633e00b2e72892a600f5e0bac60086b.svg";
export { ForwardRef as ReactComponent };